import React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { decodeColor } from "../../../helpers/color";
import ImageHeaderBox from "./ImageHeaderBox";
import Footer from "./Footer";

const PageContent = ({
    children,
    backgroundColor = null,
    title = null,
    subTitle = null,
    message = null,
    showImageHeader = true,
    imageSource = null,
    paddingTop = 0,
    paddingBottom = 20,
    footerWidth = "lg",
    ctaLabel = null,
    ctaTo = null,
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const getBackgroundSettings = () => {
        if (Boolean(backgroundColor)) {
            return {
                backgroundColor: decodeColor(backgroundColor, theme),
            };
        }

        return {};
    }

    return (
        <Box>
            <Box
                display="flex"
                flexDirection="column"
                sx={{
                    paddingTop: theme.spacing(paddingTop),
                    paddingBottom: theme.spacing(paddingBottom),
                    ...getBackgroundSettings(),
                }}
            >
                {
                    showImageHeader ? (
                        <ImageHeaderBox title={title} subTitle={subTitle} image={imageSource} message={message} ctaLabel={ctaLabel} ctaTo={ctaTo} />
                    ) : null
                }
                {children}
            </Box>
            { Boolean(footerWidth) ? <Footer footerWidth={footerWidth} /> : null }
        </Box>
    );
}

export default PageContent;
